export function findIds(results, name) {
  const ids = new Set();
  if (results && results.length > 0) {
    results.forEach((result) => {
      ids.add(result[name]);
    });
  }
  return ids;
}

export function findKind(results, id, name) {
  const map = {};
  if (results && results.length > 0) {
    results.forEach((result) => {
      const parts = result[name].split('>');
      const curName = parts[parts.length - 1];
      if (result[id] && curName && curName.length > 0) {
        if (!map[curName]) {
          map[curName] = [];
        }
        map[curName].push(result[id]);
      }
    });
  }
  return Object.keys(map).map((name) => ({
    name,
    ids: [...new Set(map[name])],
  })).sort((a, b) => a.name.localeCompare(b.name));
}
